export enum ENVIRONMENT {
  DEV = "https://prod.doyourspice.com/api",
}

export const IPOS_ID = 1;

export const LOGIN_ADMIN = {
  email: "ipos1@fuchs.ro",
  password: "afdghqtardadugUUASFG141!$5",
};

export enum AxiosMethod {
  GET = "GET",
  POST = "POST",
  DELETE = "DELETE",
  PATCH = "PATCH",
}

export interface AxiosRequestConfigInterface {
  url: string;
  method: AxiosMethod;
}

export interface GetListAxiosResponse<T> {
  data: T;
  count: number;
  lastPage: boolean;
}
